/* eslint-disable react/prop-types */
import NearestAirportSection from "./NearestAirportSection";
import PublicInfrastructureSection from "./PublicInfrastructureSection";
import NoteworthySpotsSection from "./NoteworthySpotsSection";

/**
 * LocationHighlightsTab - Container component for the Location Highlights tab.
 * Receives pre-fetched data from the backend commuter score API and renders three subsections.
 *
 * @param {{ name: string, code: string, distance: number } | null} airport - Nearest airport
 * @param {Array<{ name: string, type: string, distance: number }>} infrastructure - Public infrastructure items
 * @param {Array<{ name: string }>} spots - Noteworthy spots
 * @param {number} spotsTotal - Total noteworthy spots found
 * @param {boolean} isLoading - Whether data is still being fetched
 * @param {boolean} hasError - Whether the fetch failed
 */
const LocationHighlightsTab = ({
  airport = null,
  infrastructure = [],
  spots = [],
  spotsTotal = 0,
  isLoading = false,
  hasError = false,
}) => {
  // Loading state
  if (isLoading) {
    return (
      <div className="location-highlights-tab">
        <div className="location-highlights-tab__loading" aria-live="polite">
          <div className="commuter-score-tab__spinner" aria-hidden="true" />
          <span>Loading location highlights...</span>
        </div>
      </div>
    );
  }

  // Error state
  if (hasError) {
    return (
      <div className="location-highlights-tab">
        <p className="location-highlights-tab__error">
          Location highlights are currently unavailable
        </p>
      </div>
    );
  }

  // Success — render three sections with dividers
  return (
    <div className="location-highlights-tab">
      <div className="location-highlights-tab__sections">
        <NearestAirportSection
          airport={airport}
          hasError={false}
        />

        <div className="location-highlights-tab__divider" />

        <div className="location-highlights-tab__two-col">
          <PublicInfrastructureSection
            items={infrastructure}
            hasError={false}
          />

          <NoteworthySpotsSection
            spots={spots}
            hasError={false}
          />
        </div>
      </div>
    </div>
  );
};

export default LocationHighlightsTab;
